import React from 'react';
import Header from '../Home/Header/Header';

const Blog = () => {
    return (
        <>  
            <Header></Header>
            <div><h3 className='text-center' style={{marginTop:'80px'}}>Blog Comeing Soon!!!</h3></div>
        </>
    );
};

export default Blog;